export class IncomeCategory {
  public id?: string;
  public name: string;
}
